import { render, staticRenderFns } from "./image_item.vue?vue&type=template&id=415f629e&scoped=true&"
import script from "./image_item.vue?vue&type=script&lang=js&"
export * from "./image_item.vue?vue&type=script&lang=js&"
import style0 from "./image_item.vue?vue&type=style&index=0&id=415f629e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f629e",
  null
  
)

export default component.exports